module.exports = __webpack_public_path__ + "media/images/landkit/covers/cover-11-c28c2e8ef73c91f6ddd8bc51e7d50141.jpg";